<template>
<!-- FINAL MEMBER -->
  <form @submit.prevent>
     <CModal
        :title.sync="title"
        color="info"
        size="lg"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol lg="6">  
            <strong > Personal Information</strong>
          </CCol>
        </CRow>          
            <CRow class="mt-3" >
              <CCol >
              <b-input v-model="form.firstname" placeholder='First name' :class="errors.firstname ? 'is-invalid' : ''" id="feedback-user" class="mb-1"> </b-input>
              <b-form-invalid-feedback >
              Your firstname must be filled
              </b-form-invalid-feedback>
              </CCol>
              <CCol >
              <b-input v-model="form.lastname" placeholder='Last name' :class="errors.lastname ? 'is-invalid' : ''" id="feedback-user" class="mb-1"> </b-input>
              <b-form-invalid-feedback >
              Your lastname must be filled
              </b-form-invalid-feedback>
              </CCol>
            </CRow>
            <CRow class="mt-2">
              <CCol >
                <CInput v-model="form.alias"  placeholder='Nickname' />
              </CCol>
       
              <CCol>
                 <CInput  v-model="form.dob"  type='date' /> 
              </CCol>
            </CRow>
            <strong > Contact Information </strong>
             <CRow class="mt-3"    >
              
              <CCol >
                <CInput v-model="form.phone" placeholder='Phone Number' type="number" step="1" min="0" @keydown="filterKey" @input="filterInput" class="mb-1" />
              </CCol>
              <CCol >
                 <CInput v-model="form.mobile_phone" placeholder='Mobile Phone' type="number" step="1" min="0" @keydown="filterKey" @input="filterInput" class="mb-1" />
              </CCol>
            </CRow>
            <CRow class="mt-2">
              <CCol :col="6">
              <b-input v-model="form.email" placeholder='Email' :disabled="form.no_email === true " :class="errors.email ? 'is-invalid' : ''" id="feedback-user" class="mb-1"> </b-input>              
              <b-form-invalid-feedback>
              Example : testemail@yahoo.com
              </b-form-invalid-feedback>
              </CCol>
              <CCol :col="6">
              <b-form-checkbox  class="mt-2" id="checkbox-1" v-model="form.no_email" name="checkbox-1" >
                  Checked this box  if you didn't have an  <b>email.</b>
              </b-form-checkbox>
              </CCol>
            </CRow>
            <strong > Address Information </strong>
             <CRow class="mt-3">
              <CCol>
                <CInput v-model="form.address1"   placeholder='Address 1' />
              </CCol>
            </CRow>
             <CRow class="mt-0"    >
              <CCol >
                <CInput v-model="form.city"  placeholder='City' class="mb-1" />
              </CCol>
              <CCol >
                 <CInput v-model="form.state"  placeholder='State/Province' class="mb-1" />
              </CCol>
            </CRow>
            <CRow class="mt-2">
              <CCol :col="number">
                <CInput v-model="form.country"   placeholder='Country' />
              </CCol>
        
              <CCol :col=" number">
                 <CInput v-model="form.zipcode"  placeholder='ZipCode' />
              </CCol>
            </CRow>
            <CRow >
              <CCol >
                <CInput v-model="form.address2"   placeholder='Address 2' />
              </CCol>
            </CRow>
          <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  @click="show = false, showModal= true"  variant="outline" color="info">Next</CButton>
      </template>
       <!-- <pre> {{form | json}} </pre> -->
    </CModal>
     <CModal
         :title.sync="title"
        color="info"
        size="lg"
        :show.sync="showModal">
        <strong > Additional Information </strong>
        <CRow>
          <CCol lg="6">
            <CInput label="First Time Visiting Church" type="date" v-model="form.first_time_visit_church" class="mt-3" />
            <CInput v-model="form.previous_church" label="Previous Church" placeholder='First name'  />
            <label> is Covenant ? </label>
            <c-input-checkbox
              label="Mark this member as covenant" class="mb-3"
            />
            <CInput v-model="form.covenant_date" label="Covenant Date" type="date"  />
            <CInput v-model="form.covenant_certificate" label="Covenant Certificate No." placeholder='Certificate No.' class="mb-3" />
            <CInput v-model="form.baptism_date" label="Baptism Date" type="date"  />
           
          </CCol>
          <CCol lg="6" class="mb-4" >
            
            <CInput label="First Time Visiting iCare" type="date" v-model="form.first_time_visit_icare" class="mt-3" />
            <label> is Married ? </label>
            <c-input-checkbox
              label="Mark this member as married" class="mb-3"
            />
            <CInput v-model="form.marriage_date"  label="Marriage Date" type="date"  />
            <CInput label="Marriage Church" placeholder='Marriage Church' class="mb-3" />
            <CInput label="Marriage Certificate No." placeholder='Certificate No.' class="mb-3" />
            <CInput label="Baptism Certificate No." placeholder='Certificate No.' class="mb-3" />
            <label> Satellite Church </label>
            <b-form-select
                v-model="form.satellite_church_id"
                :options= "options"
            >
              </b-form-select>
          </CCol>
        </CRow> 
        <template #footer>
        <CButton @click="showModal = false,show= true" color="danger">Back</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Update</CButton>
      </template>
     
    </CModal>
  </form>

</template>

<script>
import EventBus from '@/eventBus';

import member from '@/services/member';
import satelite from '@/services/satelitechurch'
import icare from '@/services/icare'

import moment from 'moment';


export default {
name: 'membermodal',

  data () {
    return {
      show: false,
      
      showModal: false,
      title: 'Default Title',
      mode: '',
      errors: {},
      errors_from_backend: [],
      form:{
        uuid: '',
        id:'',
        firstname: '',
        lastname: '',
        alias:'',
        email:'',
        no_email:'false',
        dob: '',
        address1:'',
        address2:'',
        city:'',
        state:'',
        country:'',
        zipcode:'',
        previous_church:'',
        baptism_date:'',
        marriage_date:'',
        covenant_certificate:'',
        covenant_date:'',
        mobile_phone:'',
        phone:'',
        moment:'',  
        satellite_church_id:'',
        first_time_visit_church:'',
        first_time_visit_icare:''
       
      },

      options:[],
      largeModal:false,
      largeModal1:false,
      loading: false,
      
    }
    
  },
  computed: {
      validationFirstname() {
        return this.form.firstname.length > 0 
      },
       validationLastname() {
        return this.form.lastname.length > 0
      },
       validationEmail() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(this.form.email)) {
          return true;
      }
      return false;
      },
    },
  
  mounted(){

      
    
  },
  created () {
    var self = this;
      EventBus.$on('OPEN_MODAL_MEMBER', (params) => {
      if(params.data){
      member.getMemberbyID(params.data)
      .then(res => {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = params.data;
      self.form.firstname = res.data.firstname;
      self.form.lastname = res.data.lastname;
      self.form.dob = res.data.dob;
      self.form.alias = res.data.alias;
      self.form.email = res.data.email;
      self.form.address1 = res.data.address1;
      self.form.address2 = res.data.address2;
      self.form.phone = res.data.phone;
      self.form.mobile_phone = res.data.mobile_phone;
      self.form.satellite_church_id = res.data.satellite_church_id;
      self.form.city = res.data.city;
      self.form.state = res.data.state;
      self.form.country = res.data.country;
      self.form.marriage_date = res.data.marriage_date;
      self.form.zipcode = res.data.zipcode;
      self.form.covenant_date = res.data.covenant_date;
      self.form.covenant_certificate = res.data.covenant_certificate;
      self.form.baptism_date = res.data.baptism_date;
      self.form.previous_church = res.data.previous_church;
      self.form.first_time_visit_church = res.data.first_time_visit_church;
      self.form.first_time_visit_icare = res.data.first_time_visit_icare
     

       }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
         }else{
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = "";
      self.form.firstname = "";
      self.form.lastname = "";
      self.form.dob = "";
      self.form.alias = "";
      self.form.email = "";
      self.form.address1 = "";
      self.form.address2 = "";
      self.form.phone = "";
      self.form.mobile_phone = "";
      self.form.satellite_church_id = "";
      self.form.city = "";
      self.form.state = "";
      self.form.country = "";
      self.form.marriage_date = "";
      self.form.zipcode = "";
      self.form.covenant_date = "";
      self.form.covenant_certificate ="";
      self.form.baptism_date = "";
      self.form.previous_church = "";
      self.form.first_time_visit_church = "";
      self.form.first_time_visit_icare = "";
      self.form.no_email =false;
      }
      
    });
     satelite.getSateliteChurch()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.options.push({text: res.data[i].name, value:res.data[i].id})
        }
      }).catch((er) =>{
        
      })
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create (){
      this.loading = true;
      
      
      
      // this.form.dob != '' ? this.form.dob = moment(this.form.dob).format ('DD/MM/YYYY') : null
      // this.form.covenant_date != '' ? this.form.covenant_date = moment(this.form.covenant_date).format ('DD/MM/YYYY') : null
      // this.form.baptism_date != '' ? this.form.baptism_date = moment(this.form.baptism_date).format ('DD/MM/YYYY') : null
      // this.form.marriage_date != '' ? this.form.marriage_date = moment(this.form.marriage_date).format ('DD/MM/YYYY') : null
      // this.form.first_time_visit_church != '' ? this.form.first_time_visit_church = moment(this.form.first_time_visit_church).format ('DD/MM/YYYY') : null
      // this.form.first_time_visit_icare != '' ? this.form.first_time_visit_icare = moment(this.form.first_time_visit_icare).format ('DD/MM/YYYY') : null
      
      if( this.form.dob != '' ){this.form.dob  = moment(this.form.dob).format ('DD/MM/YYYY')} 
      if( this.form.covenant_date != '' ){this.form.covenant_date  = moment(this.form.covenant_date).format ('DD/MM/YYYY')} 
      if( this.form.baptism_date != '' ){this.form.baptism_date  = moment(this.form.baptism_date).format ('DD/MM/YYYY')} 
      if( this.form.marriage_date != '' ){this.form.marriage_date  = moment(this.form.dob).format ('DD/MM/YYYY')} 
      if( this.form.first_time_visit_church != '' ){this.form.first_time_visit_church  = moment(this.form.first_time_visit_church).format ('DD/MM/YYYY')} 
      if( this.form.first_time_visit_icare != '' ){this.form.first_time_visit_icare  = moment(this.form.first_time_visit_icare).format ('DD/MM/YYYY')} 


      // if( this.form.covenant_date == null ){
      //   //this.form.covenant_date  == '' 
      // } 
      // else{
      //    this.form.covenant_date= moment(this.form.covenant_date).format ('DD/MM/YYYY') ; 
      // }
      // if( this.form.baptism_date == null ){
      //   //this.form.baptism_date  == '' 
        
      // } 
      // else{
      //     this.form.baptism_date=   moment(this.form.baptism_date).format ('DD/MM/YYYY') ;
      // }

      // if( this.form.marriage_date == null ){
      //   //this.form.marriage_date  == ''
       
      // } 
      // else{
      //    this.form.marriage_date =  moment(this.form.marriage_date).format ('DD/MM/YYYY') 
      // }
      if (this.check_form()) {
      member.createMember(this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        this.showModal= false
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        this.show = false;
        }).catch((err) => {
        this.loading = false;
        alert(err.response.data.message);
        //alert(JSON.stringify(err.response.data.errors));
        if (err.response.data.errors != null) {
            this.errors_from_backend = err.response.data.errors;
            console.log(JSON.stringify(err.response.data.errors));
          }
        });
      }else{
      this.loading = false;
      }
    },
    filterKey(e){
      const key = e.key;

      // If is '.' key, stop it
      if (key === '.')
        return e.preventDefault();
      
      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e')
        return e.preventDefault();
    },
    
    // This can also prevent copy + paste invalid character
    filterInput(e){
      e.target.value = e.target.value.replace(/[^0-9]+/g, '');
    },

    update(id){
      this.show = false;

      // this.form.dob != '' ? this.form.dob = moment(this.form.dob).format ('DD/MM/YYYY') : null
      // this.form.covenant_date != '' ? this.form.covenant_date = moment(this.form.covenant_date).format ('DD/MM/YYYY') : null
      // this.form.baptism_date != '' ? this.form.baptism_date = moment(this.form.baptism_date).format ('DD/MM/YYYY') : null
      // this.form.marriage_date != '' ? this.form.marriage_date = moment(this.form.marriage_date).format ('DD/MM/YYYY') : null
      // this.form.first_time_visit_church != '' ? this.form.first_time_visit_church = moment(this.form.first_time_visit_church).format ('DD/MM/YYYY') : null
      // this.form.first_time_visit_icare != '' ? this.form.first_time_visit_icare = moment(this.form.first_time_visit_icare).format ('DD/MM/YYYY') : null

      if( this.form.dob != null ){this.form.dob  = moment(this.form.dob).format ('DD/MM/YYYY')}
      if( this.form.covenant_date != null ){this.form.covenant_date  = moment(this.form.covenant_date).format ('DD/MM/YYYY')} 
      if( this.form.baptism_date != null ){this.form.baptism_date  = moment(this.form.baptism_date).format ('DD/MM/YYYY')} 
      if( this.form.marriage_date != null ){this.form.marriage_date  = moment(this.form.marriage_date).format ('DD/MM/YYYY')} 
      if( this.form.first_time_visit_church != null ){this.form.first_time_visit_church  = moment(this.form.first_time_visit_church).format ('DD/MM/YYYY')} 
      if( this.form.first_time_visit_icare != null ){this.form.first_time_visit_icare  = moment(this.form.first_time_visit_icare).format ('DD/MM/YYYY')} 


      member.updateMember(id,this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        this.showModal= false
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },  
    check_form: function(e) {
         this.errors = {};
         if (!this.form.firstname) {
            this.errors["firstname"] = "1";
         }
         if (!this.form.lastname) {
            this.errors["lastname"] = "1";
         }
        if (!this.form.email){
          this.errors["email"] = "1";
          }
         if (
            this.form.firstname &&
            this.form.lastname &&
            this.form.email 
         ) {
            return true;
         } else {
            return false;
         }
      },
   
  }
}
</script>

<style>

</style>